import { Trans } from '@lingui/react/macro';
import { NoddiBadge, NoddiBasicCard, NoddiProgressBar } from 'noddi-ui-web';

interface Props {
  readyCount: number;
  issueCount: number;
  totalCount: number;
}

export const ReadyProgress = ({ readyCount, issueCount, totalCount }: Props) => {
  const isDone = totalCount > 0 && readyCount === totalCount;
  const percent = totalCount === 0 ? 0 : Math.round((readyCount / totalCount) * 100);

  return (
    <NoddiBasicCard className='flex flex-col gap-2'>
      <div className='flex flex-wrap items-center justify-between gap-2'>
        <span className='font-semibold'>
          {isDone ? (
            <Trans>All wheel sets are ready</Trans>
          ) : (
            <Trans>
              {readyCount} of {totalCount} ready
            </Trans>
          )}
        </span>
        {issueCount > 0 && (
          <NoddiBadge variant='destructive'>
            <Trans>{issueCount} with issues</Trans>
          </NoddiBadge>
        )}
      </div>
      <NoddiProgressBar value={percent} wrapperClassName='border-0 bg-border' className='h-2 bg-success' />
    </NoddiBasicCard>
  );
};
